
		    <header class="sticky top-0 z-50 border-b backdrop-blur shadow-sm bg-[color:var(--card)] border-[color:var(--border)]">
                <!-- Mobile: use Public-header styling for dashboards -->
                <nav class="lg:hidden mx-auto flex max-w-7xl items-center justify-between p-4" aria-label="Dashboard">
                    <div class="flex items-center gap-3 min-w-0">
                        <a [routerLink]="homeLink" class="-m-1.5 p-1.5 flex items-center gap-3">
                            <div class="h-10 px-2 flex items-center">
                                <img [src]="logoSrc" alt="nibni" class="h-8 w-auto object-contain select-none" />
                            </div>
                        </a>
                    </div>

                    <div class="flex items-center gap-2">
                        <app-theme-switcher></app-theme-switcher>

                        <app-notifications-bell></app-notifications-bell>

                        <div class="relative">
                            <button
                                type="button"
                                class="h-9 px-3 rounded-md border shadow flex items-center gap-2 text-sm font-semibold transition-colors bg-[color:var(--muted)] hover:bg-[color:var(--hover-strong)] text-[color:var(--foreground)] border-[color:var(--border)]"
                                (click)="toggleCurrency($event)"
                                aria-label="Select currency"
                            >
                                <span>{{ currencyService.currentCurrency() }}</span>
                                <lucide-icon name="chevron-down" class="h-4 w-4 pointer-events-none"></lucide-icon>
                            </button>
                            <div
                                *ngIf="openCurrency"
                                class="absolute right-0 z-50 mt-2 w-32 rounded-lg shadow-xl border bg-[color:var(--popover)] border-[color:var(--border)] max-h-72 overflow-y-auto overflow-x-hidden"
                            >
                                <button
                                    *ngFor="let currency of currencies"
                                    (click)="selectCurrency(currency)"
                                    class="w-full text-left px-4 py-2 transition-colors text-[color:var(--foreground)] hover:bg-[color:var(--hover)]"
                                >
                                    {{ currency }}
                                </button>
                            </div>
                        </div>

                        <button
                            type="button"
                            class="ml-2 inline-flex items-center justify-center rounded-md p-2.5 transition-colors text-[color:var(--muted-foreground)] hover:bg-[color:var(--hover)]"
                            (click)="toggleMobile($event)"
                        >
                            <span class="sr-only">Toggle menu</span>
                            <lucide-icon *ngIf="!openMobile" name="menu" class="h-6 w-6 pointer-events-none"></lucide-icon>
                            <lucide-icon *ngIf="openMobile" name="x" class="h-6 w-6 pointer-events-none"></lucide-icon>
                        </button>
                    </div>
                </nav>

                <!-- Mobile menu (same style as PublicHeader) -->
                <div
                    *ngIf="openMobile"
                    class="lg:hidden border-t backdrop-blur border-[color:var(--border)] bg-[color:var(--card)]"
                >
                    <div class="px-4 py-3 space-y-2">

                        <ng-container *ngIf="user$ | async as user">
                            <div class="flex items-center gap-3 rounded-lg border px-3 py-2 border-[color:var(--border)] bg-[color:var(--muted)]">
                                <div class="w-10 h-10 rounded-full overflow-hidden bg-[color:var(--secondary)] flex items-center justify-center border border-[color:var(--border)]">
                                    <ng-container *ngIf="avatarUrl; else mobileAvatarIcon">
                                        <img [src]="avatarUrl" (error)="handleAvatarError()" alt="User avatar" class="h-full w-full object-cover" />
                                    </ng-container>
                                    <ng-template #mobileAvatarIcon>
                                        <lucide-icon name="user" class="h-5 w-5 text-[color:var(--primary)]"></lucide-icon>
                                    </ng-template>
                                </div>
                                <div class="flex-1 min-w-0">
                                    <p class="text-sm font-semibold text-[color:var(--foreground)] truncate">{{ displayFullName(user) }}</p>
                                    <p class="text-xs text-[color:var(--text-subtle)] truncate">{{ displayOrgName(user) }}</p>
                                </div>
                            </div>
                            <div class="flex flex-col gap-2 pt-3">
                                <a
                                    routerLink="/profile"
                                    class="w-full border rounded-md px-4 py-2 text-center font-semibold transition-colors border-[color:var(--border)] text-[color:var(--foreground)] hover:bg-[color:var(--hover)]"
                                    (click)="closeMobile()"
                                >
                                    Profile
                                </a>
                                <a
                                    routerLink="/"
                                    class="w-full border rounded-md px-4 py-2 text-center font-semibold transition-colors border-[color:var(--border)] text-[color:var(--foreground)] hover:bg-[color:var(--hover)]"
                                    (click)="closeMobile()"
                                >
                                    Go back to main
                                </a>
                                <button
                                    type="button"
                                    class="w-full border rounded-md px-4 py-2 text-center font-semibold transition-colors border-[color:var(--border)] text-[color:var(--foreground)] hover:bg-[color:var(--hover)]"
                                    (click)="signOut(); closeMobile()"
                                >
                                    Logout
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- Desktop: keep dashboard header design -->
                <div class="hidden lg:block">
                    <div class="flex items-center justify-between gap-3 h-16 px-4 sm:px-6 lg:px-8">
                        <div class="flex flex-1 min-w-0 items-center gap-2 sm:gap-3">
                            <ng-container *ngIf="user$ | async as user">
                                <a
                                    *ngIf="contextBackLink(user) as back"
                                    [routerLink]="back.href"
                                    class="hidden sm:inline-flex items-center gap-2 rounded-lg border border-[color:var(--border)] bg-[color:var(--card)] px-3 py-2 text-xs font-semibold text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)]"
                                >
                                    <lucide-icon name="arrow-left" class="h-4 w-4"></lucide-icon>
                                    {{ back.label }}
                                </a>
                            </ng-container>
                            <div class="w-10 h-10 shrink-0 rounded-xl bg-[color:var(--secondary)] border border-[color:var(--border)] flex items-center justify-center">
                                <lucide-icon name="layout-dashboard" class="text-[color:var(--primary)] h-5 w-5"></lucide-icon>
                            </div>
                            <div class="min-w-0">
                                <h1 class="truncate text-lg sm:text-xl font-semibold text-[color:var(--foreground)] leading-tight">{{ heading }}</h1>
                                <p class="text-xs text-[color:var(--text-subtle)] leading-tight hidden sm:block">{{ subheading }}</p>
                            </div>
                        </div>

                        <div class="flex shrink-0 items-center gap-2 sm:gap-3">
                            <app-theme-switcher></app-theme-switcher>

                            <app-notifications-bell></app-notifications-bell>

                            <div class="relative">
                                <button
                                    type="button"
                                    class="h-9 px-3 sm:px-4 rounded-md border shadow flex items-center gap-2 text-sm font-semibold transition-colors bg-[color:var(--muted)] hover:bg-[color:var(--hover-strong)] text-[color:var(--foreground)] border-[color:var(--border)]"
                                    (click)="toggleCurrency($event)"
                                >
                                    <span>{{ currencyService.currentCurrency() }}</span>
                                    <lucide-icon name="chevron-down" class="h-4 w-4"></lucide-icon>
                                </button>
                                <div
                                    *ngIf="openCurrency"
                                    class="absolute right-0 z-50 mt-2 w-32 rounded-lg shadow-xl border bg-[color:var(--popover)] border-[color:var(--border)] max-h-72 overflow-y-auto overflow-x-hidden"
                                >
                                    <button
                                        *ngFor="let currency of currencies"
                                        (click)="selectCurrency(currency)"
                                        class="w-full text-left px-4 py-2 transition-colors text-[color:var(--foreground)] hover:bg-[color:var(--hover)]"
                                    >
                                        {{ currency }}
                                    </button>
                                </div>
                            </div>

                            <ng-container *ngIf="user$ | async as user; else accountFallback">
                                <div class="relative">
                                    <button
                                        type="button"
                                        (click)="toggleDropdown($event)"
                                        class="flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-[color:var(--hover)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--background)]"
                                    >
                                        <div class="w-9 h-9 rounded-full bg-[color:var(--secondary)] flex items-center justify-center border border-[color:var(--border)] overflow-hidden">
                                            <ng-container *ngIf="avatarUrl; else avatarFallback">
                                                <img [src]="avatarUrl" (error)="handleAvatarError()" alt="User avatar" class="h-full w-full object-cover" />
                                            </ng-container>
                                            <ng-template #avatarFallback>
                                                <lucide-icon name="user" class="h-4 w-4 text-[color:var(--primary)]"></lucide-icon>
                                            </ng-template>
                                        </div>
                                        <span class="text-sm text-[color:var(--muted-foreground)] hidden sm:block">{{ displayButtonName(user) }}</span>
                                        <lucide-icon name="chevron-down" class="h-4 w-4 text-[color:var(--text-subtle)]"></lucide-icon>
                                    </button>

                                    <div
                                        *ngIf="open"
                                        class="absolute right-0 mt-2 w-52 z-[2147483647] bg-[color:var(--popover)] text-[color:var(--popover-foreground)] border border-[color:var(--border)] rounded-2xl shadow-xl overflow-hidden"
                                    >
                                        <div class="px-4 py-3 border-b border-[color:var(--border)]">
                                            <p class="text-sm font-semibold text-[color:var(--foreground)]">{{ displayFullName(user) }}</p>
                                            <p class="text-xs text-[color:var(--text-subtle)]">{{ displayOrgName(user) }}</p>
                                        </div>
                                        <a routerLink="/profile" (click)="open = false" class="cursor-pointer gap-2 text-sm font-semibold hover:bg-[color:var(--hover)] flex items-center px-4 py-2">
                                            <lucide-icon name="user" class="h-4 w-4 mr-2"></lucide-icon>
                                            Profile
                                        </a>
                                        <a routerLink="/" (click)="open = false" class="cursor-pointer gap-2 text-sm font-semibold hover:bg-[color:var(--hover)] flex items-center px-4 py-2">
                                            <lucide-icon name="home" class="h-4 w-4 mr-2"></lucide-icon>
                                            Go back to main
                                        </a>
                                        <div class="border-t border-[color:var(--border)]"></div>
                                        <button
                                            type="button"
                                            (click)="signOut()"
                                            class="w-full text-left cursor-pointer gap-2 text-sm font-semibold hover:bg-[color:var(--hover)] flex items-center px-4 py-2 text-[color:var(--destructive)]"
                                        >
                                            <lucide-icon name="log-out" class="h-4 w-4 mr-2"></lucide-icon>
                                            Logout
                                        </button>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-template #accountFallback>
                                <div class="relative">
                                    <button
                                        type="button"
                                        (click)="toggleDropdown($event)"
                                        class="flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-[color:var(--hover)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--background)]"
                                    >
                                        <div class="w-9 h-9 rounded-full bg-[color:var(--secondary)] flex items-center justify-center border border-[color:var(--border)]">
                                            <lucide-icon name="user" class="h-4 w-4 text-[color:var(--primary)]"></lucide-icon>
                                        </div>
                                        <span class="text-sm text-[color:var(--muted-foreground)] hidden sm:block">Your Account</span>
                                        <lucide-icon name="chevron-down" class="h-4 w-4 text-[color:var(--text-subtle)]"></lucide-icon>
                                    </button>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </header>

    <div *ngIf="showDisplayCurrencyPrompt" class="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 px-4">
        <div class="relative w-full max-w-md rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] p-6 text-[color:var(--foreground)] shadow-2xl">
            <button type="button" (click)="closeDisplayCurrencyPrompt()" class="absolute right-3 top-3 rounded-full bg-slate-100 p-2 hover:bg-slate-200">
                <lucide-icon name="x" class="h-4 w-4 text-slate-700"></lucide-icon>
            </button>
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-[color:var(--secondary)] text-[color:var(--primary)] mb-4 border border-[color:var(--border)]">
                <lucide-icon name="circle-dollar-sign" class="h-6 w-6"></lucide-icon>
            </div>
            <h3 class="text-xl font-semibold mb-2">Select Display Currency</h3>
            <p class="text-sm text-slate-600">
                Display currency is an approximation and is to be used for your reference only to view balance, assets, and property marketplace in your preferred currency.
            </p>
            <p class="mt-3 text-sm text-slate-600">
                By selecting a display currency, you hereby confirm that you understand that your display currency is to be used by you as a reference.
            </p>
            <button type="button" (click)="closeDisplayCurrencyPrompt()" class="mt-5 w-full rounded-lg bg-[color:var(--primary)] px-4 py-2 text-[color:var(--primary-foreground)] font-semibold transition-colors hover:bg-[color:var(--primary-hover)]">
                Got it
            </button>
        </div>
    </div>
    
